import { collection, doc, } from "firebase/firestore";
// Typed collection/document references for the Doc 02 §8 flat layout. Centralising
// the string paths here keeps them off the repositories and out of sync drift.
export const paths = (db) => ({
    users: () => collection(db, "users"),
    user: (uid) => doc(db, "users", uid),
    friends: (uid) => collection(db, "users", uid, "friends"),
    friend: (uid, friendId) => doc(db, "users", uid, "friends", friendId),
    userLookup: (emailHash) => doc(db, "userLookup", emailHash),
    trips: () => collection(db, "trips"),
    trip: (id) => doc(db, "trips", id),
    categories: () => collection(db, "categories"),
    category: (id) => doc(db, "categories", id),
    items: () => collection(db, "items"),
    item: (id) => doc(db, "items", id),
    todos: () => collection(db, "todos"),
    todo: (id) => doc(db, "todos", id),
    notes: () => collection(db, "notes"),
    note: (id) => doc(db, "notes", id),
    templates: () => collection(db, "templates"),
    template: (id) => doc(db, "templates", id),
    templateCategories: () => collection(db, "templateCategories"),
    templateItems: () => collection(db, "templateItems"),
    templateTodos: () => collection(db, "templateTodos"),
    friendRequests: () => collection(db, "friendRequests"),
    friendRequest: (id) => doc(db, "friendRequests", id),
    friendships: () => collection(db, "friendships"),
    friendship: (pairKey) => doc(db, "friendships", pairKey),
    shareLinks: () => collection(db, "shareLinks"),
    shareLink: (token) => doc(db, "shareLinks", token),
    managedProfiles: () => collection(db, "managedProfiles"),
    managedProfile: (id) => doc(db, "managedProfiles", id),
    pendingInvites: () => collection(db, "pendingInvites"),
    pendingInvite: (id) => doc(db, "pendingInvites", id),
    accessGrants: () => collection(db, "accessGrants"),
    accessGrant: (resourceId, uid) => doc(db, "accessGrants", `${resourceId}_${uid}`),
});
//# sourceMappingURL=paths.js.map